<template>
  <div class="">
    <!-- Carrito de compras -->
    <!-- <ShoppingCart></ShoppingCart> -->
    <!-- Banner si estamos dentro de la galleria -->
    <div
      class="headerClass flex flex-col md:flex-row border-b border-yellow-photo pb-4 mb-4 container mx-auto items-center px-4 md:px-8"
      v-if="isGalleryRoute()"
    >
      <div class="md:flex items-center">
        <img
          :src="$S3AssetUrl('/suf/logos/albumes/park-' + parkId + '.png')"
          alt="logo parque"
          class="w-auto h-18 logo-gallery"
        />
      </div>
      <!---->
      <div class="flex flex-auto justify-end">
        <div
          id="timerOut"
          class="md:flex flex-row items-center justify-center font-semibold text-sm"
        >
          <template v-if="visitDate != null">
            <!-- <template v-if="unlocked">
              {{ $tc("messages.countdown_albumes") }}
              <span class="flex text-lg font-bold ml-2">
                {{
                  $tc("messages.countdown_days_albumes", diffDays(visitDate))
                }}
              </span>
            </template>
            <template v-else>
              {{ $t("messages.countdown_buy_albumes") }}
              <span class="flex text-lg font-bold ml-2">
                {{
                  $tc("messages.countdown_days_albumes", diffDays(visitDate))
                }}
              </span>
            </template> -->
          </template>
        </div>
        <!-- <AddNewAlbum /> -->

        <div
          id="cartMenu"
          @click="showMenu()"
          class="shadownBottom md:flex flex-row items-center justify-center relative cursor-pointer bg-yellow-photo rounded-full px-4 ml-4 py-2"
        >
          <template>
            <span
              class="counter animate-ping absolute z-10 bg-red-600 rounded-full border h-4 w-4 -top-1 -right-1 pointer-events-none"
            >
            </span>
            <span
              class="counter absolute z-10 text-white bg-red-600 rounded-full border h-4 w-4 text-xxs flex justify-center items-center -top-1 -right-1 pointer-events-none"
              >{{ $store.state.shoppingCartAmount }}</span
            >
          </template>
          <span class="font-bold mr-1 hidden-less-ipad">{{ $t("cart.my_cart") }}</span>
          <span class="albumes addcart material-icons">
            local_grocery_store
          </span>
        </div>
      </div>
    </div>

    <!-- Banner si es Tag | Room -->
    <div
      class="headerClass flex flex-col md:flex-row border-b border-yellow-photo pb-4 mb-6 container mx-auto items-center px-4 md:px-8"
      v-else-if="
        $store.getters.getCodesType == 1 || $store.getters.getCodesType == 2
      "
    >
      <div class="md:flex items-center">
        <img
          :src="$S3AssetUrl('suf/home/photo-pass-logo.png')"
          alt="logo parque"
          class="w-auto h-18"
        />
      </div>
      <div
        class="hidden flex flex-col flex-1 md:pl-4 items-center md:items-start text-3xl font-bold text-black"
      >
        Mis Álbumes
      </div>
      <div class="flex flex-auto justify-end">
        <AddNewAlbum />

        <div
          id="cartMenu"
          @click="showMenu()"
          class="shadownBottom md:flex flex-row items-center justify-center relative cursor-pointer bg-yellow-photo rounded-full px-4 ml-4 py-2"
        >
          <template>
            <span
              class="counter animate-ping absolute z-10 bg-red-600 rounded-full border h-4 w-4 -top-1 -right-1 pointer-events-none"
            >
            </span>
            <span
              class="counter absolute z-10 text-white bg-red-600 rounded-full border h-4 w-4 text-xxs flex justify-center items-center -top-1 -right-1 pointer-events-none"
              >{{ $store.state.shoppingCartAmount }}</span
            >
          </template>
          <span class="font-bold mr-1">{{ $t("cart.my_cart") }}</span>
          <span class="albumes addcart material-icons">
            local_grocery_store
          </span>
        </div>
      </div>
    </div>

    <!-- Banner por defecto -->
    <div
      class="headerClass flex flex-col md:flex-row /*border-b border-yellow-photo*/ pb-4 mb-4 container mx-auto items-center px-4 md:px-8"
      v-else
    >
      <div class="md:flex items-center">
        <img
          :src="$S3AssetUrl('suf/home/photo-pass-logo.png')"
          alt="logo parque"
          class="hidden w-auto h-18"
        />
      </div>
      <div class="hidden flex flex-col flex-1 md:pl-4 md:items-start">
        <div class="text-green-xcaret text-xl font-bold mb-2">Mis fotos</div>
        <p class="text-grey w-full text-sm mb-4 md:mb-0">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat
        </p>
      </div>
      <div class="addNewAndShoppingCart flex flex-1 justify-end">   

        <AddNewAlbum />

        <div
          id="cartMenu"
          @click="showMenu()"
          class="shadownBottom item md:flex flex-row items-center justify-center relative cursor-pointer bg-yellow-photo rounded-full px-4 ml-4 py-2"
        >
          <template>
            <span
              class="counter animate-ping absolute z-10 bg-red-600 rounded-full border h-4 w-4 -top-1 -right-1 pointer-events-none"
            >
            </span>
            <span
              class="counter absolute z-10 text-white bg-red-600 rounded-full border h-4 w-4 text-xxs flex justify-center items-center -top-1 -right-1 pointer-events-none"
              >{{ $store.state.shoppingCartAmount }}</span
            >
          </template>
          <span class="font-bold mr-1">{{ $t("cart.my_cart") }}</span>
          <span class="albumes addcart material-icons">
            local_grocery_store
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HelperMix from "../mixins/helper";
import ShoppingCartMix from "../mixins/ShoppingCart";
import MenuMix from "../mixins/Menu";
import AddNewAlbum from "../AddNewAlbum.vue";
// import ShoppingCart from "../ShoppingCartComponent.vue";

export default {
  props: {
    visitDate: {
      type: String,
      default: null,
    },
    parkId: {
      type: Number,
      default: null,
    },
    unlocked: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [HelperMix, ShoppingCartMix, MenuMix],
  components: {
    AddNewAlbum,
  },
  data: () => ({
    // uuid: 100,
  }),
  computed: {},
  methods: {
    isGalleryRoute() {
      return (
        this.$route.name === "gallery" || this.$route.name === "es.gallery"
      );
    },
  },
  created() {},
};
</script>
